export default __webpack_public_path__ + "static/privacy-shield-framework-logo-451904afb46bf0fdf6a1fa7be855ba22.svg";